// auto-generated by Typewriter template _models.tst from PortCall.Pilots.EndPoints\App\ViewOriginalPilotOrder\ViewOriginalPilotOrderViewModel.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { PortCall, PortCallData, PortCallOptions } from 'data/models/PortCall';

// OriginalPilotOrderData is the class that OriginalPilotOrder serializes to/from
export interface OriginalPilotOrderData {
    PortCallId : number;
	
    OriginalOrder : PortCallData | null;
	
}

// OriginalPilotOrderOptions is the class which may be passed to the OriginalPilotOrder constructor to define optional initial data values
export interface OriginalPilotOrderOptions {
    PortCallId : number;
	
    OriginalOrder? : PortCallOptions | null;
	
}

export class OriginalPilotOrder {
    public PortCallId : DataSignal<number>;
	
    public OriginalOrder : DataSignal<PortCall | null>;
	

    constructor();
    constructor(data : OriginalPilotOrderOptions);
    constructor(data: OriginalPilotOrderOptions | null = null) {
        this.PortCallId = jsonableObservable(S.value<number>(data && data.PortCallId !== undefined ? data.PortCallId : 0));
	    
        this.OriginalOrder = S.value<PortCall | null>(null);
	    
    }

    static key(obj : OriginalPilotOrder) {
        return obj.PortCallId();
    }
    
    static dataKey(obj : OriginalPilotOrderOptions) {
        return obj.PortCallId;
    }

    static update(obj : OriginalPilotOrder, data : OriginalPilotOrderOptions) {
        S.freeze(() => {
            if (data.PortCallId !== undefined) obj.PortCallId(data.PortCallId);
	        
	        
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/OriginalPilotOrder.ts